module.exports = __webpack_public_path__ + "static/img/mk-bg.016542e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mk-bg.png
// module id = bEav
// module chunks = 9